// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"870":"553eb402","989":"e739150d"}[chunkId] + ".chunk.js";
};